export const FETCH_ACCOUNTTRXS = 'FETCH_ACCOUNTTRXS';
export const PUSH_ACCOUNTTRXS = 'PUSH_ACCOUNTTRXS';
export const REMOVE_ACCOUNTTRXS = 'REMOVE_ACCOUNTTRXS';
export const UPDATE_ACCOUNTTRXS = 'UPDATE_ACCOUNTTRXS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchAccounttrxs(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_ACCOUNTTRXS,
      payload:data
    });
  }
}

export function pushAccounttrxs(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_ACCOUNTTRXS,
      payload:data
    });
  }
}

export function removeAccounttrxs(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_ACCOUNTTRXS,
      payload:data
    });
  }
}

export function updateAccounttrxs(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACCOUNTTRXS,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActiveAccounttrxs(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
